<div class="button__wrapper" [style.justify-content]="position">
  <button
    class="btn"
    [class.shadow]="shadow"
    [ngClass]="classname"
    [type]="type"
    [disabled]="disabled || loading"
    (click)="onClick($event)"
  >
    <span *ngIf="loading" class="fas fa-circle-notch fa-spin loader" [class.hide-content]="isContentHidden"></span>
    <ng-container *ngIf="!isContentHidden">
      <ng-content></ng-content>
    </ng-container>
  </button>
</div>
